import { authenticatedGet, authenticatedPost, authenticatedDelete } from '../utils/apiUtils';
import { CHARITIES_URL } from '../api-config';

export const getCharities = () => authenticatedGet(CHARITIES_URL);

export const getCharityById = (charityId) => authenticatedGet(`${CHARITIES_URL}/${charityId}`);

// Create a charity. Per the Stripe-funds-segregation backend, the payload must
// include a non-empty `stripe_account_id`; the server runs Stripe Connect
// verification on create and rejects with STRIPE_ACCOUNT_INVALID if it fails.
export const createCharity = (charityData) => authenticatedPost(CHARITIES_URL, charityData);

// Re-verify a charity's Stripe Connect account. Optionally pass an override
// account id; if omitted the backend re-verifies the stored one. Persists
// is_stripe_verified / stripe_charges_enabled / stripe_last_verified_at and
// returns the VerifyStripeAccountResult.
export const verifyCharityStripeAccount = (charityId, stripeAccountId) =>
  authenticatedPost(
    `${CHARITIES_URL}/${charityId}/verify-stripe-account`,
    stripeAccountId ? { stripe_account_id: stripeAccountId } : {}
  );

export const deleteCharity = async (charityId) => {
  const response = await authenticatedDelete(`${CHARITIES_URL}/${charityId}`);
  return response;
};

// NOTE: There is no `PUT /charities/{id}` route in the Stripe-funds-segregation
// backend. Charity details are set at creation time; the only post-create
// mutation is re-verifying the Stripe account via verifyCharityStripeAccount.
